module.exports = __webpack_public_path__ + "img/yzm5.0d0241a1.png";